import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TaskAnalyticsModeEnum } from '@zaoblako/shared/modules/task/enum/task-analytics-mode.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link TaskAnalyticsModeEnum} enumeration values */
export const TaskAnalyticsModeEnumI18n: EnumI18nInterface<TaskAnalyticsModeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [TaskAnalyticsModeEnum.BY_BALANCE_REPORT]: 'По ОПиУ/ДДС',
    [TaskAnalyticsModeEnum.BY_PAYMENT_CALENDAR]: 'По платежному календарю'
  },
  [I18nLocalesEnum.EN_US]: {
    [TaskAnalyticsModeEnum.BY_BALANCE_REPORT]: 'By Balance Report',
    [TaskAnalyticsModeEnum.BY_PAYMENT_CALENDAR]: 'By Payment Calendar'
  },
};
